import { QueryClient, useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { Socket } from 'socket.io-client';
import { useSocketIoFactory } from './useSocketIoFactory';
import { interceptorDataParser } from '@starsoft/common/utils/parsers';
import { Nullable } from '@starsoft/common/interfaces';
import { UserRestriction } from '@/models/user-restriction';
import { useDispatch } from 'react-redux';
import {
  setUnreachableRestriction,
  setUserRestrictions,
} from '@/lib/store/user-restrictions/actions';
import { useRouter } from 'next/router';
import { ModalsKey } from '@/enums/modalsKey';
import { Restriction } from '@/models/restriction';

export default function useUserRestrictionsSocket() {
  const dispatch = useDispatch();
  //@ts-ignore
  const { push, pathname } = useRouter();

  const socket: Nullable<Socket> = useSocketIoFactory({
    gateway: 'user-restrictions',
    isProtected: true,
  });
  const queryClient: QueryClient = useQueryClient();

  const handleBlockedRestriction = useCallback(
    (userRestriction: UserRestriction): void => {
      dispatch(setUserRestrictions(userRestriction));
      push({
        hash: ModalsKey.UserRestrictionsDetails,
      });
    },
    [dispatch, push],
  );

  const handleUnreachableRestriction = useCallback(
    (restriction: Restriction): void => {
      dispatch(setUnreachableRestriction(restriction));
      push({
        pathname,
        hash: ModalsKey.UserRestrictionsDetails,
      });
    },
    [dispatch, push],
  );

  function setServerOnEvents() {
    if (!socket) return;

    socket.on('blocked-restriction', (data: UserRestriction) => {
      const parsedData = interceptorDataParser(data);
      handleBlockedRestriction(parsedData);
    });

    socket.on('unreachable-restriction', (data: Restriction) => {
      const parsedData = interceptorDataParser(data);
      handleUnreachableRestriction(parsedData);
    });
  }

  useEffect(setServerOnEvents, [socket, queryClient]);
}
